
define(
	'Code25.CaterpartsGlobal.Privacy'
	, [
		"Utils", 'Configuration', 'js.cookie','Tools'
	]
	, function (
		Utils, Configuration, Cookies, Tools
	) {
		'use strict';
		return {
			mount: function mount(container) {
				//sort facets
				var CookieWarningBannerView = require("CookieWarningBanner.View");
				if (CookieWarningBannerView) {
					if (CookieWarningBannerView.CookieWarningBannerView) {
						CookieWarningBannerView = CookieWarningBannerView.CookieWarningBannerView;
					}
					_.extend(CookieWarningBannerView.prototype, {

						reject: function (e) {
							Cookies.set('Cookies', "No", { expires: 3650 });
							window.location.reload();

						},
						closeMessage: _.wrap(CookieWarningBannerView.prototype.closeMessage, function (closeMessage) {

							Cookies.set('Cookies', "Yes", { expires: 3650 });
							this.render();
						}), getContext: function getContext() {

							var showBanner;
							if (!Tools.isApp()) {
								showBanner = (
									Configuration.get('siteSettings.showcookieconsentbanner') === 'T' &&
									!(
										Configuration.get('cookieWarningBanner.saveInCookie', false) &&
										!!Cookies.get('Cookies')
									)
								);
							}
							// @class CookieWarningBanner.View.Context
							return {
								// @property {Boolean} showBanner
								showBanner: showBanner,
								// @property {String} cookieMessage
								cookieMessage: Configuration.get('cookieWarningBanner.message', ''),
								// @property {Boolean} showLink
								showLink: !!Configuration.get('siteSettings.cookiepolicy', false),
								// @property {String} linkHref
								linkHref: Configuration.get('siteSettings.cookiepolicy', false),
								// @property {String} linkContent
								linkContent: Configuration.get('cookieWarningBanner.anchorText', ''),
								// @property {Boolean} showLink
								closable: Configuration.get('cookieWarningBanner.closable', true)
							};
							// @class CookieWarningBanner.View
						}
					});

					CookieWarningBannerView.prototype.events['click [data-action="reject"]'] = 'reject';

				}

				var GoogleTagManagerModel=require("GoogleTagManager.Model");
				if(GoogleTagManagerModel&&Configuration.get('siteSettings.showcookieconsentbanner') === 'T'){
					
					_.extend(GoogleTagManagerModel.prototype, {

						save: _.wrap(GoogleTagManagerModel.prototype.save, function (save) {

							var res = save.apply(this, _.rest(arguments));

							//console.log("save",res);
							return res;
						})
					});
				}

			}

		}

	});
